import React from 'react';
import { Helmet } from 'react-helmet-async';
import EmptyState from '../components/common/EmptyState';
import './NotFoundPage.css';

const NotFoundIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <path d="M14 2v6h6" />
    <path d="M9.2 13.5h.01" />
    <path d="M12 13.5h.01" />
    <path d="M14.8 13.5h.01" />
    <path d="M9 17h6" />
  </svg>
);

const NotFoundPage = () => (
  <>
    <Helmet>
      <title>페이지를 찾을 수 없어요 | 왓퀴즈</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
    <main className="not-found-page">
      <EmptyState
        icon={<NotFoundIcon />}
        title="페이지를 찾을 수 없어요"
        description="주소가 바뀌었거나 삭제된 페이지예요"
        primaryAction={{ label: '홈으로 가기', to: '/' }}
        secondaryAction={{ label: 'AI 채팅 열기', to: '/chat' }}
      />
    </main>
  </>
);

export default NotFoundPage;
